/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Email_PlaceholderInputs */

const en_user_email_placeholder = /** @type {(inputs: User_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email@example.com`)
};

const ja_user_email_placeholder = /** @type {(inputs: User_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`name@example.com`)
};

const fr_user_email_placeholder = /** @type {(inputs: User_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nom@example.com`)
};

const de_user_email_placeholder = /** @type {(inputs: User_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`name@example.com`)
};

/**
* | output |
* | --- |
* | "email@example.com" |
*
* @param {User_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_email_placeholder = /** @type {((inputs?: User_Email_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Email_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_email_placeholder(inputs)
	if (locale === "ja") return ja_user_email_placeholder(inputs)
	if (locale === "fr") return fr_user_email_placeholder(inputs)
	return de_user_email_placeholder(inputs)
});